import React from 'react';

import { Spacer } from '@/components/common';
import { Skeleton } from '@/components/memo';

import './TimelinePlaceholder.css';

interface TimelinePlaceholderProps {
  isFirst?: boolean;
  isLast?: boolean;
}

const TimelinePlaceholder: React.FC<TimelinePlaceholderProps> = ({
  isFirst,
  isLast
}) => {
  return (
    <div
      className={`timeline-item ${!isLast ? 'timeline-item--connects-next' : ''}`}
    >
      <div className="timeline-item__time">
        <div
          className={`timeline-item__circle ${!isFirst ? 'timeline-item__circle--overlapped-start-time' : ''}`}
        >
          <Skeleton className="timeline-placeholder__time-skeleton" />
        </div>
        <div className="timeline-item__line"></div>
        {isLast && (
          <div className="timeline-item__circle timeline-item__circle--end-time">
            <Skeleton className="timeline-placeholder__time-skeleton" />
          </div>
        )}
      </div>
      <div className="timeline-item__content">
        <p className="timeline-item__patient">
          <Skeleton className="timeline-placeholder__patient-skeleton" />
        </p>
        <Spacer top={2} bottom={8}>
          <p className="timeline-item__purpose">
            <Skeleton className="timeline-placeholder__purpose-skeleton" />
          </p>
        </Spacer>
        <div className="timeline-item__details">
          <p className="timeline-item__gender">
            <Skeleton className="timeline-placeholder__icon-skeleton" />
            <Skeleton className="timeline-placeholder__gender-skeleton" />
          </p>
          <p className="timeline-item__birthday">
            <Skeleton className="timeline-placeholder__icon-skeleton" />
            <Skeleton className="timeline-placeholder__birthday-skeleton" />
          </p>
          <p className="timeline-item__mobile-number">
            <Skeleton className="timeline-placeholder__icon-skeleton" />
            <Skeleton className="timeline-placeholder__mobile-number-skeleton" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default TimelinePlaceholder;
